import CallsPage from 'react-components/calls-page/calls-page';
import { useNavigate } from 'react-router-dom';
import { Routes, SyncHook } from '../route-types';

const CALLS_PATH = '/calls';

const routes: Routes = [
  {
    path: CALLS_PATH,
    element: <CallsPage />,
  },
];

const useSyncHook: SyncHook = null;

const useNavigationHooks = () => {
  const navigate = useNavigate();
  return {
    toCalls: (filters?: { onlyUnassignedCalls?: boolean }) => {
      if (filters?.onlyUnassignedCalls) {
        // Update the callsFilterConfig in localStorage
        const existingConfig = window.localStorage.getItem('callsFilterConfig');
        const config = existingConfig ? JSON.parse(existingConfig) : {};
        config.onlyUnassignedCalls = true;
        window.localStorage.setItem(
          'callsFilterConfig',
          JSON.stringify(config)
        );
      }
      navigate(CALLS_PATH);
    },
  };
};

export const callsPageRouteConfig = {
  routes,
  useSyncHook,
  useNavigationHooks,
};
